import React, { ReactElement } from 'react';
import Head from 'next/head';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { withAuth } from 'lib/hocs/withAuth';
import EditCompanyProfile from './EditCompanyProfile';

import styles from './Company.module.scss';

const EditProfile = (): ReactElement => {
  return (
    <>
      <Head>
        <title>Company Profile | Huzzle</title>
        <meta name="description" content="Huzzle" />
      </Head>
      <section className={styles.CompanyProfile} data-testid="CompanyProfile">
        <EditCompanyProfile />
      </section>
    </>
  );
};
export async function getStaticProps({ locale }: { locale: string }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, 'common')),
    },
  };
}
const EditProfileWrapper = withAuth(EditProfile);

export default EditProfileWrapper;
